import { Icon, IconProps } from "../Icon";

const Download = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 15L24.59 13.59L17 21.17V2H15V21.17L7.41 13.59L6 15L16 25L26 15ZM26 24V28H6V24H4V28C4 29.1046 4.89543 30 6 30H26C27.1046 30 28 29.1046 28 28V24H26Z"
      fill="currentColor"
    />
  </Icon>
);

export default Download;
